document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-drsq-header]').forEach((header) => {
    const toggle = header.querySelector('[data-drsq-menu-toggle]');
    const desktopMedia = window.matchMedia('(min-width: 990px)');
    const desktopItems = Array.from(header.querySelectorAll('[data-drsq-nav-item]'));

    const closeDesktopMenus = (exceptItem = null) => {
      desktopItems.forEach((item) => {
        if (exceptItem && item === exceptItem) return;
        item.classList.remove('is-open');
        item.querySelector('[data-drsq-desktop-trigger]')?.setAttribute('aria-expanded', 'false');
      });
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', header.classList.contains('is-open') ? 'true' : 'false');
      });
    }

    desktopItems.forEach((item) => {
      const trigger = item.querySelector('[data-drsq-desktop-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', (event) => {
        if (!desktopMedia.matches) return;
        event.preventDefault();
        const shouldOpen = !item.classList.contains('is-open');
        closeDesktopMenus(item);
        item.classList.toggle('is-open', shouldOpen);
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });
    });

    document.addEventListener('click', (event) => {
      if (!desktopMedia.matches) return;
      if (header.contains(event.target)) return;
      closeDesktopMenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeDesktopMenus();
    });

    const resetDesktopMenus = () => closeDesktopMenus();
    if (typeof desktopMedia.addEventListener === 'function') {
      desktopMedia.addEventListener('change', resetDesktopMenus);
    } else {
      window.addEventListener('resize', resetDesktopMenus);
    }
  });

  document.querySelectorAll('[data-drsq-tabs]').forEach((tabs) => {
    const buttons = Array.from(tabs.querySelectorAll('[data-drsq-tab-button]'));
    const panels = Array.from(tabs.querySelectorAll('[data-drsq-tab-panel]'));
    const activate = (key) => {
      buttons.forEach((button) => {
        const active = button.dataset.drsqTabButton === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.drsqTabPanel === key);
      });
      const activePanel = panels.find((panel) => panel.dataset.drsqTabPanel === key);
      activePanel?.querySelectorAll('[data-drsq-rail]').forEach((rail) => {
        if (typeof rail.drsqReset === 'function') {
          rail.drsqReset();
        }
      });
    };
    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.drsqTabButton));
    });
    if (buttons[0]) activate(buttons[0].dataset.drsqTabButton);
  });

  document.querySelectorAll('[data-drsq-rail]').forEach((rail) => {
    const track = rail.querySelector('[data-drsq-rail-track]');
    if (!track) return;
    const buttons = Array.from(rail.querySelectorAll('[data-drsq-scroll]'));
    const progressThumb =
      rail.querySelector('[data-drsq-rail-progress-thumb]') ||
      rail.parentElement?.querySelector('[data-drsq-rail-progress-thumb]') ||
      rail.closest('[data-drsq-tab-panel]')?.querySelector('[data-drsq-rail-progress-thumb]');

    const getScrollAmount = () => {
      if (rail.dataset.drsqScrollStep === 'item') {
        const firstItem = track.firstElementChild;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : 0;
        if (itemWidth > 0) {
          return itemWidth + gap;
        }
      }

      return Math.max(track.clientWidth * 0.84, 260);
    };

    const updateRailChrome = () => {
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      buttons.forEach((button) => {
        const direction = Number(button.dataset.drsqScroll || '1');
        if (direction < 0) {
          button.disabled = track.scrollLeft <= 4;
          return;
        }
        button.disabled = track.scrollLeft >= maxScroll - 4;
      });

      if (!progressThumb) return;
      const visibleRatio = maxScroll > 0 ? track.clientWidth / track.scrollWidth : 1;
      const thumbWidth = Math.min(1, Math.max(visibleRatio, 0.18));
      const progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      progressThumb.style.width = `${thumbWidth * 100}%`;
      progressThumb.style.left = `${progress * (100 - thumbWidth * 100)}%`;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.drsqScroll || '1');
        track.scrollBy({ left: direction * getScrollAmount(), behavior: 'smooth' });
      });
    });

    rail.drsqReset = () => {
      track.scrollTo({ left: 0, behavior: 'auto' });
      updateRailChrome();
    };

    track.addEventListener('scroll', updateRailChrome, { passive: true });
    window.addEventListener('resize', updateRailChrome);
    updateRailChrome();
  });

  document.querySelectorAll('[data-drsq-gallery]').forEach((gallery) => {
    const viewport = gallery.querySelector('[data-drsq-gallery-viewport]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-drsq-thumb]'));
    if (!viewport || !thumbs.length) return;

    const activateThumb = (mediaId) => {
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.drsqThumb === mediaId));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = viewport.querySelector(`[data-drsq-media-id="${thumb.dataset.drsqThumb}"]`);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', inline: 'start' });
        activateThumb(thumb.dataset.drsqThumb);
      });
    });

    viewport.addEventListener(
      'scroll',
      () => {
        const slides = Array.from(viewport.querySelectorAll('[data-drsq-media-id]'));
        if (!slides.length) return;
        const snap = slides
          .map((slide) => ({
            id: slide.dataset.drsqMediaId,
            distance: Math.abs(slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left),
          }))
          .sort((a, b) => a.distance - b.distance)[0];
        if (snap?.id) activateThumb(snap.id);
      },
      { passive: true },
    );

    activateThumb(thumbs[0].dataset.drsqThumb);
  });

  const colorMap = {
    black: '#202020',
    white: '#f5f5f5',
    blue: '#6e8cae',
    green: '#7a9572',
    red: '#b95b47',
    brown: '#7c5e46',
    orange: '#d98a41',
    yellow: '#dcb64b',
    gray: '#9b9b9b',
    grey: '#9b9b9b',
    purple: '#7660a9',
    pink: '#e5a4b8',
    natural: '#c9b28a',
    tan: '#b69472',
    clear: '#d8d8d8',
  };

  document.querySelectorAll('[data-drsq-product-root]').forEach((root) => {
    const variantScript = root.querySelector('[data-drsq-variants]');
    const optionButtons = Array.from(root.querySelectorAll('[data-option-position][data-option-value]'));
    const variantInput = root.querySelector('[data-drsq-variant-id]');
    const priceNode = root.querySelector('[data-drsq-price]');
    const compareNode = root.querySelector('[data-drsq-compare]');
    const oneTimePriceNode = root.querySelector('[data-drsq-onetime-price]');
    const qtyInput = root.querySelector('[data-drsq-qty-input]');
    const submitButton = root.querySelector('[data-drsq-submit]');
    const gallery = root.querySelector('[data-drsq-gallery]');
    let variants = [];

    try {
      variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
    } catch (error) {
      variants = [];
    }

    const selected = {};
    optionButtons.forEach((button) => {
      const pos = button.dataset.optionPosition;
      if (!(pos in selected) && button.classList.contains('is-active')) {
        selected[pos] = button.dataset.optionValue;
      }
    });

    const scrollToMedia = (mediaId) => {
      if (!mediaId || !gallery) return;
      const viewport = gallery.querySelector('[data-drsq-gallery-viewport]');
      const slide = gallery.querySelector(`[data-drsq-media-id="${mediaId}"]`);
      if (!viewport || !slide) return;
      slide.scrollIntoView({ behavior: 'smooth', inline: 'start' });
      gallery.querySelectorAll('[data-drsq-thumb]').forEach((node) => {
        node.classList.toggle('is-active', node.dataset.drsqThumb === String(mediaId));
      });
    };

    const updateVariant = () => {
      if (!variants.length) return;
      const match =
        variants.find((variant) => {
          return (variant.options || []).every((value, index) => String(value) === String(selected[index + 1] || value));
        }) || variants[0];

      if (variantInput) variantInput.value = String(match.id);
      if (priceNode) priceNode.textContent = match.price || '';
      if (oneTimePriceNode) oneTimePriceNode.textContent = match.price || '';
      if (compareNode) {
        compareNode.textContent = match.compare_at_price || '';
        compareNode.style.display = match.compare_at_price ? '' : 'none';
      }
      if (submitButton) {
        submitButton.disabled = !match.available;
        submitButton.textContent = match.available ? submitButton.dataset.availableLabel || 'Add to Cart' : submitButton.dataset.soldOutLabel || 'Sold Out';
      }
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', String(match.id));
      window.history.replaceState({}, '', nextUrl.toString());
      if (match.featured_media_id) scrollToMedia(match.featured_media_id);
    };

    optionButtons.forEach((button) => {
      const label = button.dataset.optionValue || '';
      const normalized = label.toLowerCase();
      if (button.classList.contains('drsq-option-button--swatch') || button.classList.contains('drsq-card__option--swatch')) {
        const color = colorMap[normalized] || colorMap[normalized.split(' ')[0]] || '#d7c6a3';
        button.style.setProperty('--swatch-color', color);
      }
      button.addEventListener('click', () => {
        const pos = button.dataset.optionPosition;
        selected[pos] = button.dataset.optionValue;
        root.querySelectorAll(`[data-option-position="${pos}"]`).forEach((node) => node.classList.remove('is-active'));
        button.classList.add('is-active');
        updateVariant();
      });
    });

    root.querySelectorAll('[data-drsq-qty-change]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!qtyInput) return;
        const delta = Number(button.dataset.drsqQtyChange || '0');
        const current = Number(qtyInput.value || '1');
        qtyInput.value = String(Math.max(1, current + delta));
      });
    });

    updateVariant();
  });

  document.querySelectorAll('[data-drsq-story-section]').forEach((section) => {
    const modal = section.querySelector('[data-drsq-story-modal]');
    const video = modal?.querySelector('[data-drsq-story-video]');
    const image = modal?.querySelector('[data-drsq-story-image]');
    const closeButtons = Array.from(section.querySelectorAll('[data-drsq-story-close]'));
    const triggers = Array.from(section.querySelectorAll('[data-drsq-story-trigger]'));
    const previewVideos = Array.from(section.querySelectorAll('[data-drsq-preview-video]'));

    if (!modal || !video || !image || !triggers.length) return;

    const markPreviewReady = (preview) => {
      preview.closest('.drsq-nation__media')?.classList.add('is-ready');
    };

    const markPreviewFallback = (preview) => {
      preview.closest('.drsq-nation__media')?.classList.add('is-fallback');
    };

    const playPreview = (preview) => {
      preview.muted = true;
      preview.defaultMuted = true;
      preview.loop = true;
      preview.playsInline = true;
      preview.play().catch(() => {});
    };

    const pausePreviews = () => {
      previewVideos.forEach((preview) => preview.pause());
    };

    const resumeVisiblePreviews = () => {
      previewVideos.forEach((preview) => {
        const rect = preview.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < window.innerHeight;
        if (visible) playPreview(preview);
      });
    };

    if (previewVideos.length) {
      const previewObserver =
        'IntersectionObserver' in window
          ? new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  const preview = entry.target;
                  if (!(preview instanceof HTMLVideoElement)) return;
                  if (entry.isIntersecting) {
                    playPreview(preview);
                  } else {
                    preview.pause();
                  }
                });
              },
              { threshold: 0.35 },
            )
          : null;

      previewVideos.forEach((preview) => {
        preview.addEventListener('loadeddata', () => markPreviewReady(preview), { once: true });
        preview.addEventListener('playing', () => markPreviewReady(preview), { once: true });
        preview.addEventListener('error', () => markPreviewFallback(preview), { once: true });
        if (previewObserver) {
          previewObserver.observe(preview);
        } else {
          playPreview(preview);
        }
      });
    }

    const resetMedia = () => {
      video.pause();
      video.removeAttribute('src');
      video.removeAttribute('poster');
      video.muted = false;
      video.loop = false;
      video.classList.add('is-hidden');
      video.load();
      image.removeAttribute('src');
      image.alt = '';
      image.classList.add('is-hidden');
    };

    const closeModal = () => {
      modal.hidden = true;
      modal.classList.remove('is-active');
      document.body.classList.remove('drsq-story-modal-open');
      resetMedia();
      resumeVisiblePreviews();
    };

    const openModal = (trigger) => {
      const poster = trigger.dataset.storyPoster || '';
      const storyVideo = trigger.dataset.storyVideo || trigger.dataset.storyPreviewVideo || '';
      const title = trigger.dataset.storyTitle || 'Customer story';

      pausePreviews();
      resetMedia();
      modal.hidden = false;
      modal.classList.add('is-active');
      document.body.classList.add('drsq-story-modal-open');

      if (storyVideo) {
        video.src = storyVideo;
        if (poster) video.poster = poster;
        video.muted = false;
        video.controls = true;
        video.loop = false;
        video.classList.remove('is-hidden');
        video.play().catch(() => {});
        return;
      }

      if (poster) {
        image.src = poster;
        image.alt = title;
        image.classList.remove('is-hidden');
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => openModal(trigger));
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  });
});
